function getBoxStyles(props) {
  const {
    flex,
    inline = true,
    center,
    minWidth,
    maxWidth,
    maxHeight,
    minHeight,
    fullWidth,
    m,
    mb,
    mt,
    ml,
    mr,
    p,
    pb,
    pt,
    pl,
    pr,
    ...restProps
  } = props;
  const boxStyles = {
    flex,
    inline,
    center,
    minWidth,
    maxWidth,
    maxHeight,
    minHeight,
    fullWidth,
    m,
    mb,
    mt,
    ml,
    mr,
    p,
    pb,
    pt,
    pl,
    pr
  };
  return {
    boxStyles,
    restProps
  };
}
export default getBoxStyles;